import React from "react";

const NotFound = () => {
  return <div className="not-found">Oopss! Page Not Found!</div>;
};

export default NotFound;
